import Breakpoints from 'breakpoints-js/dist/breakpoints';
import { breakpoints } from './.config';

// Create a mobileState property to help manage viewport based functionality.
Object.defineProperty(Breakpoints, 'mobileState', {
  get() {
    return this.current().max < this.get('desktop').min;
  },
});

// Create a new instance with our configured breakpoints.
Breakpoints(breakpoints);

export default Breakpoints;
